import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type {
  IRegisterAffiliateReferralFields,
} from '../types';
import {
  REGISTER_AFFILIATE_REFERRAL_MUTATION_KEY,
  REGISTER_AFFILIATE_REFERRAL_URL,
} from '../constants';

export default function useRegisterAffiliateReferralMutation(): IContextMutationResult<void, Error, IRegisterAffiliateReferralFields> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IRegisterAffiliateReferralFields>({
    mutationKey: [REGISTER_AFFILIATE_REFERRAL_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(REGISTER_AFFILIATE_REFERRAL_URL, payload),
  });
}
